import React, { useEffect, useRef, useState } from 'react';
import { ISearchInput } from './interfaces';
import { useTranslation } from 'react-i18next';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';

export const SearchInput: React.FC<ISearchInput> = ({
  value,
  placeholder,
  onChange,
}): JSX.Element => {
  const { t } = useTranslation();

  const debounceSearchTimer = useRef<ReturnType<typeof setTimeout> | null>(
    null
  );
  const [searchText, setSearchText] = useState<string>(value || '');
  const [searchValue, setSearchValue] = useState<string>(value || '');

  const onSearchTextChange = (search: string) => {
    setSearchText(search.trim());

    if (debounceSearchTimer.current) {
      clearTimeout(debounceSearchTimer.current); // Oude timer opruimen
    }

    debounceSearchTimer.current = setTimeout(() => {
      setSearchValue(search.trim());
    }, 400);

    return () => {
      if (debounceSearchTimer.current) {
        clearTimeout(debounceSearchTimer.current); // Opruimen bij unmount of wijziging
      }
    };
  };

  const onClearSearch = (): void => {
    setSearchText('');
    setSearchValue('');
  };

  useEffect(() => {
    onChange(searchValue);
  }, [searchValue]);

  return (
    <TextField
      variant="outlined"
      size="small"
      placeholder={placeholder || t('forms:search.placeholder')}
      value={searchText}
      onChange={(e) => onSearchTextChange(e.target.value)}
      sx={{
        width: { xs: '100%', mobile: 300 },
        bgcolor: '#FFF',
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon
              sx={{
                width: '20px',
                height: '20px',
              }}
            />
          </InputAdornment>
        ),
        endAdornment: searchText ? (
          <InputAdornment position="end">
            <IconButton size="small" onClick={onClearSearch}>
              <ClearIcon
                sx={{
                  width: '20px',
                  height: '20px',
                }}
              />
            </IconButton>
          </InputAdornment>
        ) : undefined,
      }}
    />
  );
};
